const CryptoJS = require('crypto-js');

// Helper class to handle encryption and decryption
class CryptoHelper {
  constructor(secretKey) {
    let _secretKey = secretKey;

    // Function to encrypt data using AES
    const encrypt = (data) => {
      try {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), _secretKey).toString();
        return encryptedData;
      } catch (error) {
        return null;
      }
    };

    // Function to decrypt data using AES
    const decrypt = (encryptedData) => {
      try {
        const decryptedData = CryptoJS.AES.decrypt(encryptedData, _secretKey);
        const parsedData = JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
        return parsedData;
      } catch (error) {
        return null;
      }
    };

    this.encrypt = encrypt;
    this.decrypt = decrypt;
  }
}

// Use environment variable for secret key
const secretKey = process.env.REACT_APP_ENC_DEC_SECRET_KEY;
const cryptoHelper = new CryptoHelper(secretKey);

export default cryptoHelper;
